import Actions from 'actions'
import { PatientBriefModalMode } from 'consts/hiToolsConsts'
import { isEmpty } from 'lodash'
import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getStatusTypeByKey } from 'utils/statusUtils'

export default ({ analyticsSource }) => {
  const dispatch = useDispatch()
  const patient = useSelector(state => state.patientsReducer.patient)
  const patientCardTreatment = useSelector(state => state.patientsReducer.patientCard.treatment?.data)
  const statusesByProgram = useSelector(state => state.treatmentReducer.statuses?.data || {})

  const {
    id: patientId,
    details: patientDetails,
    treatments,
    statusType: patientStatusType,
    user,
    programData
  } = patient

  const currentTreatment = useMemo(
    () => treatments?.items?.[0] || patient?.treatment || patientCardTreatment,
    [patient, patientCardTreatment, treatments]
  )
  const parsedProgramData = useMemo(() => {
    if (!programData) {
      return {}
    }

    try {
      return JSON.parse(programData)
    } catch (error) {
      return {}
    }
  }, [programData])
  const postConfirmationStatusKey = useMemo(
    () => currentTreatment?.postConfirmationStatusKey || parsedProgramData?.postConfirmationStatusKey,
    [currentTreatment, parsedProgramData]
  )
  const treatmentType = useMemo(() => currentTreatment?.type, [currentTreatment])
  const statusType = useMemo(() => {
    const currentStatusType =
      patientStatusType || currentTreatment?.currentStatus?.status?.type || patientDetails?.statusType

    if (currentStatusType !== 'invited') {
      return currentStatusType
    }

    return (
      getStatusTypeByKey({
        statusesByProgram,
        program: user?.program,
        statusKey: postConfirmationStatusKey
      }) || currentStatusType
    )
  }, [currentTreatment, patientDetails, patientStatusType, postConfirmationStatusKey, statusesByProgram, user])

  const viewPatientBrief = useCallback(
    ({ patientBrief }) => {
      dispatch(
        Actions.togglePatientBriefModal({
          isOpen: true,
          mode: PatientBriefModalMode.View,
          patientId,
          patientName: patientDetails?.name,
          statusType,
          originalPatientBrief: patientBrief,
          analyticsSource
        })
      )
    },
    [dispatch, patientId, patientDetails, statusType, analyticsSource]
  )

  const updatePatientBrief = useCallback(
    ({ patientBrief }) => {
      const hasSavedPatientBrief = !isEmpty(patientBrief)
      dispatch(
        Actions.togglePatientBriefModal({
          isOpen: true,
          mode: hasSavedPatientBrief ? PatientBriefModalMode.Update : PatientBriefModalMode.NewPatient,
          patientId,
          patientName: patientDetails?.name,
          treatmentType: treatmentType,
          statusType,
          originalPatientBrief: patientBrief,
          analyticsSource
        })
      )
    },
    [analyticsSource, dispatch, patientDetails, patientId, statusType, treatmentType]
  )

  return {
    viewPatientBrief,
    updatePatientBrief
  }
}
